import React, { useState, useMemo, useContext } from "react";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import UploadData from "components/Patrimoine/UploadData";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";

import { getSite } from "services/ConfigServices";

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const UploadButton = styled.div`
margin-left: 15px;
&:hover {
  cursor: pointer;
}
`;

const TableName = styled.h1`
margin-right: auto;
margin-left: -8px;
font-size: 1.3rem;
font-weight: 500;
`;

export default function useEntitesTable(
  parameters,
  addUserDialog,
  buttonTitle,
  dialogTitle,
  listTitle
) {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");

  const [totalRows, setTotalRows] = useState(0);

  const url = getSite(chartIdGroup,"equipments.equipmentlist");

  const { results, loading, error, refetch, invalidate } = useApi(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserService.getToken()}`,
    },
  });

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // ----------------------------------------------------------

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);


  const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const UploadComponent = ({ onUpload }) => (
    <>
      <UploadButton type="button" onClick={onUpload}>
        {/*<PublishIcon fontSize="medium" />
        <UploadText>Import</UploadText>*/}
        <UploadData
          type="button"
          onClick={onUpload}
          open={open}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          buttonTitle={buttonTitle}
          dialogTitle={dialogTitle}
          content={addUserDialog}
        />
      </UploadButton>
    </>
  );

  const filteredItems = _.get(
    results,
    `detail.equipments.equipmentlist`,
    []
  ).filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.clef && item.clef.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.category && item.category.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);

    return (
      <>
        <TableName>{""}</TableName>
        <FilterComponent
          key="FilterComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {realestateupdate ? <UploadComponent key="UploadComponent" onUpload={handleClear} /> : <></>}
      </>
    );
  }, [filterText, resetPaginationToggle, open]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
      noDataComponent: <NoData>Aucun équipement à afficher</NoData>,
      paginationComponentOptions:
        {noRowsPerPage : false,
        rowsPerPageText : "Lignes par page",
        rangeSeparatorText : "sur",
        selectAllRowsItem : false,
        selectAllRowsItemText : "Selectionner toutes les lignes"}
      ,
    },
    error,
    refetch,
    invalidate,
    handleClose,
  };
}
